import React from "react";
import { Input, InputGroup } from "reactstrap";

/**
 * String building block (SCRUM-551, VariableField registry).
 *
 * Contract: receives the variable entry, reports only the clean value via
 * `onChange(name, value)`. Controlled, like both Handle* screens' current
 * String inputs.
 *
 * NOTE: the name-based String special-cases (`logo`/`option` → image picker,
 * `reviewer` → user select) stay in the host screens for now — flagged as
 * tech debt in the refactor design doc (§6); they move in step 5/6.
 */
export type StringFieldProps = {
  settingVar: { variable: string; value?: string | number };
  onChange: (name: string, value: string) => void;
};

export default function StringField({ settingVar, onChange }: StringFieldProps) {
  return (
    <InputGroup className="input-group-merge">
      <Input
        placeholder={`insert value for ${settingVar.variable}`}
        type="text"
        value={settingVar.value}
        name={settingVar.variable}
        onChange={(e) => onChange(settingVar.variable, e.target.value)}
      />
    </InputGroup>
  );
}
